import { z } from "zod";

export const companySchema = z.object({
  id: z.number(),
  company_name: z.string().nullish(),
  status: z.object({
    id: z.number(),
    name: z.string(),
  }),
  has_improvement_proposal: z.coerce.boolean(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export type Company = z.infer<typeof companySchema>;
